import React, { Component } from 'react';
import { Doughnut } from 'react-chartjs-2';

function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

const getState = () => ({
    labels: [
        'Red',
        'Green',
        'Yellow'
    ],
    datasets: [{
        data: [getRandomInt(50, 200), getRandomInt(100, 150), getRandomInt(150, 250)],
        backgroundColor: [
            '#CCC',
            '#36A2EB',
            '#FFCE56'
        ],
        hoverBackgroundColor: [
            '#FF6384',
            '#36A2EB',
            '#FFCE56'
        ]
    }]
});


class PieChart extends Component {


    constructor(props) {
        super(props);
        this.state = {
            labels: [
                'Red',
                'Green',
                'Yellow'
            ],
            datasets: [{
                data: [getRandomInt(50, 200), getRandomInt(100, 150), getRandomInt(150, 250)],
                backgroundColor: [
                    '#CCC',
                    '#36A2EB',
                    '#FFCE56'
                ],
                hoverBackgroundColor: [
                    '#FF6384',
                    '#36A2EB',
                    '#FFCE56'
                ]
            }]
        }
    }

    getInitialState = () => {
        return getState();
    }

    componentWillMount = () => {
        setInterval(() => {            
            this.setState(getState());
        }, 5000);
    }


    render() {
        return (
            <div>
                <div className="card main-shadow" >
                    <h4 className="text-center">{this.props.title}</h4>
                    <Doughnut data={this.state} />
                </div>

            </div>
        );
    }
}

export default PieChart;
